import React, { useEffect, useState } from 'react';
import Sidebar from '../../Common/Sidebar/Sidebar';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '../globalStyle.css';
import { toast } from "react-toastify";
import AddCategoryPopup from '../../Common/Popup/AddCategoryPopup';
import Modal from 'react-modal';
import axios from 'axios';
import { isMobile } from 'react-device-detect';



const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: isMobile ? "100%" : '55%'
  },
};

export default function AddBoyan() {
    const mainTopic = "Boyan"
    const [boyanInfo, setBoyanInfo] = useState({});
    const [popup, setPopup] = useState(false);

    const [categoryList, setCategoryList] = useState([])

    useEffect(()  => {        
      async function fetchData() {
       const category = await axios.get(`https://ahlehaqserver.herokuapp.com/api/category/${mainTopic}`)
       setCategoryList(category.data.response);
      }
      fetchData() 
    },[popup])

    const saveBoyan = async (e) => {
        e.preventDefault();
        try {
              const boyanInserted = await axios.post(
                `https://ahlehaqserver.herokuapp.com/api/boyan`,
                boyanInfo
              );
      
              //if request success, will show success notification
              if (boyanInserted.data.code === 200) {
                setBoyanInfo({});
                toast.success("Boyan added successfully!");
                e.target.reset();
              }
          
            
        } catch (error) {
          console.log(error);
          // toast.error("Internal Server Error!");
        }
      };

    return (
        <div>
          <Modal isOpen={popup} style={customStyles}>
                <AddCategoryPopup
                topic={mainTopic}
                setPopup={setPopup}
                />
            </Modal>
            <div className="row">
                <div className="col-md-3">
                    <Sidebar/>
                </div>
                <div className="col-md-9">
                   <h1 className="ml-4">Add a new Boyan</h1>
                    
                   <form onSubmit={saveBoyan}>
                      <div className="row">
                         <div className="col-md-5 col-8">
                          <div className="form-group">
                              <label for="exampleInputEmail1" className="font-weight-bold">
                                Select category<span className="text-danger">*</span>
                              </label>
                              
                              <select
                                className="form-control rounded"
                                id="exampleInputEmail1"
                                name="category"
                                value={boyanInfo?.category || ""}
                                required
                                onChange={(e) =>
                                    setBoyanInfo((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.value,
                                  }))
                                }
                              >
                                <option>
                                {
                                    categoryList.length === 0 ? "Click add button and create new category" :
                                    "Choose from the list or create a new category"
                                  }
                                </option>
                                {categoryList &&
                                  categoryList.map((data) => (
                                    <option value={data.category}>
                                      {data.category}
                                    </option>
                                  ))}
                              </select>  
                          </div>
                        </div>
                        <div className="col-md-1 col-2 addBtnPadding" >
                            <button 
                            type="button"
                            className="btn btn-success addBtn"
                            onClick={() => setPopup(true)}
                            >
                                + Add
                            </button>
                        </div>

                        <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                            Boyan Title<span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              placeholder="example: AF4SE3250"
                              id="exampleInputPassword1"
                              name="title"
                              value={boyanInfo?.title || ""}
                              required
                              onChange={(e) =>
                                setBoyanInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>

                         <div className="col-md-6">
                          <div className="form-group">
                            <label htmlFor="exampleInputPassword1" className="font-weight-bold">
                              Video url <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control rounded"
                              id="exampleInputPassword1"
                              name="videoUrl"
                              value={boyanInfo?.videoUrl || ""}
                              required
                              placeholder="Example: https://example.com"
                              onChange={(e) =>
                                setBoyanInfo((prev) => ({
                                  ...prev,
                                  [e.target.name]: e.target.value,
                                }))
                              }
                            />
                          </div>
                         </div>
                          
                         {/* <div className="col-md-12">
                            <CKEditor
                                editor={ ClassicEditor }
                                config={ editorConfiguration }
                                data={boyanInfo?.description || ""}
                                onChange={ ( event, editor ) => {
                                    const data = editor.getData();
                                    setBoyanInfo((Prev) => ({ ...Prev, description: data }))
                                  
                                } }
                            />
                         </div>   */}
                          
                         <div className="col-md-4">
                            <div className="mt-4 ">
                              <button
                                type="submit"
                                className="btn btn-success rounded-pill px-4 ml-auto"
                              >
                                Done
                              </button>
                            </div>  
                         </div> 

                      </div>

                    </form>
                </div>
            </div>
        </div>
    )
}
